





















































import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import { mapState } from 'vuex';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import {
  Grant,
} from '@/api/grant';
import { Account } from '@/api/consumeraccountdetails';

interface GrantTableEntry {
  status: string;
  expirationSortDate: number;
  originalAmount: string;
  amountRemaining: string;
}

@Component({
  computed: mapState(['fiId']),
})
export default class TunesGrantsSheet extends Vue {
  @Prop({ default: false }) value!: boolean;

  @Prop() grants!: Grant[];

  @Prop() account!: Account;

  @Prop() relationship!: string;

  show: boolean = false;

  fiId!: string;

  loading: boolean = true;

  entries: GrantTableEntry[] = [];

  headers: DataTableHeader[] = [
    { text: 'Status', value: 'expirationSortDate' },
    { text: 'Original Amount', value: 'originalAmount' },
    { text: 'Amount', value: 'amount' },
  ];

  mounted() {
    this.show = this.value;
    if (this.show) {
      this.buildEntries();
    }
  }

  @Watch('value')
  onNewValue() {
    this.show = this.value;
    if (this.show) {
      this.buildEntries();
    } else {
      // Clear out the table when closed so that when re-opened we're scrolled to the top
      this.entries = [];
    }
  }

  onShowToggle(newValue: boolean) {
    this.show = newValue;
    this.$emit('input', this.show);
  }

  buildEntries() {
    this.entries = [];

    let totalRemaining = 0;
    this.grants.forEach((grant: Grant) => {
      this.entries.push({
        status: `Expires ${new Date(grant.expirationDate).toLocaleDateString('en-US', { timeZone: 'UTC' })}`,
        expirationSortDate: new Date(grant.expirationDate).getTime(),
        originalAmount: `$${grant.amount}`,
        amountRemaining: `$${Number(grant.amountRemaining).toFixed(2)}`,
      });
      totalRemaining += grant.amountRemaining;
    });

    this.headers[2].text = `Amount (Total outstanding grants amount $${Number(totalRemaining).toFixed(2)})`;
  }
}
